import React from 'react';

class FieldPlayer extends React.Component 
{

	constructor(props)
	{
		super(props);

		this.onDragStart = this.onDragStart.bind(this);
		this.onDrop = this.onDrop.bind(this);
	}

	onDrop(event)
	{
		var otherNum = event.dataTransfer.getData("text");
		this.props.onPlayerSwitch(this.props.playerNum, otherNum);
	}

	onDragOver(event)
	{
		event.preventDefault();
	}

	onDragStart(event)
	{
		event.dataTransfer.setData("text/plain", this.props.playerNum);
	}

	render() {
		return (
			<div draggable onDragOver={this.onDragOver} onDragStart={this.onDragStart} onDrop={this.onDrop} style={{ position: "absolute", left: this.props.playerPosition.x - 100 + "px", top: this.props.playerPosition.y + "px", textAlign: "center" }}>
				<div className={"player" + this.props.playerTeam} />
				<div className="playerName">
					{this.props.playerName}
				</div>
			</div>

		);
	}
}

export default FieldPlayer;
